/*
 * @Descripttion: 导出
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-07 10:48:26
 * @LastEditors: bbq
 * @LastEditTime: 2020-08-07 16:28:00
 */
import Selectable from './selectable';
import hoc from './hoc';

Selectable.HOC = hoc;

export default Selectable;